import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import ToastComponent from '../../components/toast';
import { CompanyLogoService } from '../../services/wealthlane-customer-services';

const usePostCompanyProfileLogo = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<boolean | undefined, unknown, any, unknown> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        CompanyLogoService.postApiCustomerApiAppCompanyLogoSaveCompanyLogo(payload)
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response != null && response !== false) {
          await queryClient.invalidateQueries('getProfileImage');
          toast.success(<ToastComponent label='Success' message='Company Logo Updated!' />);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostCompanyProfileLogo;
